var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      value: _vm.value,
      items: _vm.tags,
      loading: _vm.loading,
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      label: "Select Tags",
      multiple: "",
      outlined: "",
      chips: "",
      "small-chips": "",
      "deletable-chips": "",
      "hide-details": "",
      "prepend-inner-icon": "tag",
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }